import { Navigate, Outlet } from "react-router-dom";
import { useBootDeps } from "../lib/boot/deps";
import { StatusScreen } from "../components/StatusScreen";
import { useT } from "../i18n";
import { useSession, useSessionManager } from "../store/session/SessionProvider";
import { homeFor, roleAllows } from "./table";
import type { RouteRole } from "./table";

/**
 * 세션 가드. 세션이 없으면 /launch(→ FS-C1-02), 세션 오류면 FS-C1 상태 화면,
 * 역할이 다르면 자기 홈으로 보낸다(학생에게 교사 화면·그 반대를 보이지 않음).
 */
export function RequireSession({ role }: { role: Exclude<RouteRole, "public"> }) {
  const state = useSession();
  const manager = useSessionManager();
  const deps = useBootDeps();
  const t = useT();

  if (state.status === "idle" || state.status === "pending")
    return <div className="pf-pane" aria-busy="true" aria-label={t("common.loading")} />;
  if (state.status === "none") return <Navigate to="/launch" replace />;
  if (state.status === "error") {
    return (
      <StatusScreen
        code={state.code}
        audience="student"
        actions={[
          state.retryable
            ? { label: t("common.retry"), icon: "↻", onClick: () => void manager.retry() }
            : { label: t("common.toCampus"), icon: "↩", onClick: deps.backToCampus },
        ]}
      />
    );
  }
  const actual = state.session.role;
  if (!roleAllows(role, actual)) return <Navigate to={homeFor(actual)} replace />;
  return <Outlet />;
}
